import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 px-4" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <FadeIn className="bg-surface border border-mint/20 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-xl" data-id="element-61">
          <div className="absolute top-0 left-0 w-full h-2 bg-mint" data-id="element-62" />

          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-mint/10 mb-4" data-id="element-63">
            <ShieldCheck size={40} className="text-mint" data-id="element-64" />
          </div>

          <h2 className="font-display text-3xl md:text-4xl font-bold mb-4 text-mint" data-id="element-65">
            🛡️ PROBALO 7 DÍAS SIN RIESGO
          </h2>

          <div className="space-y-4 text-lg md:text-xl text-white/80 max-w-2xl mx-auto" data-id="element-66">
            <p data-id="element-67">
              Estamos tan seguras de que este sistema te va a ahorrar tiempo,
              ordenar tu trabajo y facilitar tus intervenciones, que podés
              probarlo durante 7 días.
            </p>
            <p className="font-bold text-mint" data-id="element-68">
              Si sentís que no te ayuda a trabajar con más claridad, más orden y
              menos estrés, escribinos y te devolvemos el 100%.
            </p>
            <p className="text-white/60 text-base" data-id="element-69">
              Sin preguntas. Sin formularios. Sin vueltas.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}